import { Component, OnDestroy, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { NAV_ITEMS, NavItem } from '../../../navigation/nav-items';
import { SidebarFlyoutDirective } from './sidebar-flyout/sidebar-flyout.directive';
import { SidebarFlyoutComponent } from './sidebar-flyout/sidebar-flyout.component';

@Component({
  selector: 'app-base-sidebar',
  imports: [CommonModule, RouterModule, SidebarFlyoutDirective, SidebarFlyoutComponent],
  templateUrl: './base-sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './base-sidebar.component.scss',
})
export class BaseSidebarComponent implements OnDestroy {
  isCollapsed = false;
  isHome = false;
  readonly navItems = NAV_ITEMS.filter((i) => !i.hide);
  private routerSub?: Subscription;
  private userOverride = false;
  private readonly BREAKPOINT = 1280;

  constructor(private router: Router) {
    // Set initial collapsed state based on viewport width
    try {
      if (typeof window !== 'undefined') {
        this.isCollapsed = this.getViewportWidth() < this.BREAKPOINT;
      }
    } catch {
      // ignore (SSR / tests without window)
    }
    this.routerSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((ev) => {
        const seg = ev.urlAfterRedirects.replace(/^\//, '').split('/')[0] || '';
        this.isHome = seg === 'home' || seg === '';
      });
    // Ensure collapsed state after router setup in case earlier attempt failed
    this.isCollapsed = this.getViewportWidth() < this.BREAKPOINT;
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  goHome() {
    this.router.navigate(['/home']);
  }

  toggle() {
    this.userOverride = true;
    this.isCollapsed = !this.isCollapsed;
    this.userOverride = true; // prevent auto-resizing after manual toggle
  }

  trackByNav = (_: number, item: NavItem) => item.route + '|' + item.label;

  getViewportWidth(): number {
    try {
      return typeof window !== 'undefined' ? window.innerWidth : this.BREAKPOINT + 1; // default to expanded
    } catch {
      return this.BREAKPOINT + 1;
    }
  }

  @HostListener('window:resize')
  onResize() {
    if (this.userOverride) return;
    const shouldCollapse = this.getViewportWidth() < this.BREAKPOINT;
    if (shouldCollapse !== this.isCollapsed) {
      this.isCollapsed = shouldCollapse;
    }
  }
}
